import React, { useEffect } from "react";
import "./Solution2.css";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import Dolibarr from "../../assest/solutions/Dolibarr Feature​.png";
import Dolibarr1 from "../../assest/solutions/Dolibarr Feature​ 1.png";

const OpensourceERP = () => {
  useEffect(() => {
    window.scrollTo(0, 0);  
  }, []);

  return (
    <>
      <Header />
      <div className="resilience-container">
        {/* Hero Section */}
        <div className="hero-section">
          <div className="hero-content">
            <div class="backup-container">
              <a href="/solutions#Opensource" class="backup-text">
                Solution
              </a>
              <p class="backup-text">/Opensource ERP​ ​​​</p>
            </div>

            <div className="hero-wrapper">
              <div className="hero-text-container">
                <div className="hero-text-content">
                  <h1 className="hero-title">
                    <span className="hero-title-main">
                      Opensource ERP​​ ​​​
                    </span>
                  </h1>
                  <p className="hero-subtitle">
                    "Streamline Your Business Processes with Dolibarr ERP —
                    Affordable Excellence for SMEs"​
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <div className="introduction-text">
            <b>Introduction :</b> After a decade of using this Opensource ERP
            internally, we would like to share our knowledge and experience of
            this good software to our customer. In the quest for operational
            efficiency and cost management, SMEs face unique challenges.
            Dolibarr ERP offers a robust, open-source solution that empowers
            businesses to manage their end-to-end operations without the
            financial burden of traditional ERP systems. Our services aim to
            tailor this adaptable software to fit the intricacies of your
            business perfectly.​​
          </div>

          <h2 className="section-title">Why Dolibarr ERP?​</h2>
          <div class="boost-productivity-container">
            <p class="boost-productivity-text">
              <b>Cost-Effective </b>: Significantly reduce your operational
              costs with a free, open-source solution.​​​
            </p>
            <p class="boost-productivity-text">
              <b>Comprehensive Functionality </b>: From sales and CRM to
              accounting and inventory, Dolibarr covers all the bases.​
            </p>

            <p class="boost-productivity-text">
              <b>Customizable </b>: Modular design allows for customization to
              cater to your specific business needs.​​
            </p>
            <p class="boost-productivity-text">
              <b>User-Friendly </b>: A simple and intuitive interface ensures
              ease of use without a steep learning curve.​​ Scalable : Suitable
              for small businesses yet robust enough to scale with your
              growth.​​​
            </p>
            <p class="boost-productivity-text">
              <b>Scalable </b>: Suitable for small businesses yet robust enough
              to scale with your growth.​​​
            </p>
          </div>
        </div>

        <h2 className="section-title">Our Services​​</h2>
        <div class="boost-productivity-container">
          <p class="boost-productivity-text">
            1.Custom Implementation of Dolibarr ERP​​​​​​
          </p>
          <p class="boost-productivity-text">
            2.On-Premise or Cloud Hosting Solutions​​ ​
          </p>
          <p class="boost-productivity-text">
            3.Tailored Module Development​​ ​​
          </p>
          <p class="boost-productivity-text">
            4.Data Migration and System Integration​ ​
          </p>
          <p class="boost-productivity-text">
            5.Ongoing Support and Maintenance
          </p>
          <p class="boost-productivity-text">
            6.Training for Staff to Ensure Smooth Transition​​
          </p>
        </div>
        <h2 className="section-title">How You Benefit​​​​​​ ​​​</h2>
        <div class="boost-productivity-container">
          <p class="boost-productivity-text">
            1.Gain real-time visibility into your operations.​
          </p>
          <p class="boost-productivity-text">
            2.Make informed decisions with integrated analytics.​
          </p>

          <p class="boost-productivity-text">
            3.Automate and optimize your business processes.​
          </p>
          <p class="boost-productivity-text">
            4.Enjoy the flexibility to adapt to market changes quickly.​​
          </p>
          <h2>Dolibarr Feature​​​​</h2>
          <br />

          <img src={Dolibarr} alt="Dolibarr1" className="Dolibarr-image" />
          <img src={Dolibarr1} alt="Dolibarr1" className="Dolibarr-image" />
          <p class="boost-productivity-text">
            "Embrace a smarter way to do business with Dolibarr ERP. Let us help
            you unlock its full potential for your company."​​​
          </p>
        </div>

        <div class="button-container">
        <a href="/contactus?subject=Opensource%20ERP" class="contact-button">Contact Us</a>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OpensourceERP;
